// Flux
import { TypedAction } from "@ms/uno-fluxcore/lib/local/actions/Action";
import { ActionType } from "../ActionType";
export class FetchTodoSettingsAction extends TypedAction(ActionType.FetchTodoSettingsAction) {
}
export class FetchTodoSettingsFailedAction extends TypedAction(ActionType.FetchTodoSettingsFailedAction) {
}
export class FetchTodoSettingsSucceededAction extends TypedAction(ActionType.FetchTodoSettingsSucceededAction) {
    constructor(settings){
        super(), this.settings = settings;
    }
}
